/**
 * Entry point. Constructs the client and the model, mounts the UI.
 *
 * `VITE_WS_URL` is compiled in at build time — same reason the Dart app's
 * endpoint is a `--dart-define`: a URL fetched at runtime is a URL that
 * anything on the network path can rewrite, and there is no reason the
 * origin should be able to redirect its own game to another backend.
 */

import { GameClient } from './net.js';
import { GameModel } from './game.js';
import { mount } from './ui.js';

const wsUrl = import.meta.env.VITE_WS_URL;
if (typeof wsUrl !== 'string' || wsUrl.length === 0) {
  const root = document.getElementById('root')!;
  root.textContent =
    'VITE_WS_URL is missing at build time. Deploy with SST, or run ' +
    '`VITE_WS_URL=wss://… npm run web:dev` locally.';
  throw new Error('missing VITE_WS_URL');
}

const client = new GameClient(wsUrl);
const model = new GameModel(client);

const root = document.getElementById('root');
if (root === null) throw new Error('#root missing from index.html');
mount(root, model);
